import * as React from 'react';
import BillingNav from './nav';
import Pending from './pending';
// import BilledByCenter from './billed-by-center';
import AccountsReceivable from './accounts-receivable';
import AccountsPayable from './accounts-payable';
import BilledToCenter from './billed-to-center';
import NotBilled from './not-billed';
import BilledManually from './billed-manually';
import Upcoming from './upcoming';
import Search from './search';
import ViewEdit from './view-edit';
import ViewCharges from './view-charges';
import PayThroughNkrList from './universal-bill-pay/list';
import PayThroughNkr from './universal-bill-pay/add-edit';
import SubmittedByRecipientCenter from './submitted-by-recipient-center';
import { ContentWrapper } from './styles';
import AccountsReceivableOpo from './accounts-receivable-opo';
import AccountsPayableTotal from './accounts-payable-total';
import AccountsTotalStatement from './accounts-total-statement';

interface IProps {
    subSection: string,
    centerId: number,
    centerAlias: string,
    id?: number
}

interface IState {
    tabText: string
}

class Billing extends React.Component<IProps, IState> {
    readonly state: IState = {
        tabText: ''
    }

    componentWillMount = () => { }

    componentDidMount = () => { }

    handleTabSelect = (key: string) => { }

    handleViewEditLoaded = (tabText: string) => {
        this.setState({
            tabText
        });
    }

    render = () => {
        const activeKey = this.props.subSection.toUpperCase();

        return (
            <div style={{ padding: '0px 10px' }}>
                <BillingNav
                    activeKey={activeKey}
                    tabText={this.state.tabText}
                    centerId={this.props.centerId}
                    centerAlias={this.props.centerAlias}
                    onTabSelect={this.handleTabSelect}
                />

                <ContentWrapper>
                    {/* {activeKey.toUpperCase() == 'PENDING' && (
                        <Pending
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}

                    {activeKey.toUpperCase() == 'BILLED-TO-CENTER' && (
                        <BilledToCenter
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}

                    {activeKey.toUpperCase() == 'UPCOMING' && (
                        <Upcoming
                            centerId={this.props.centerId}
                        />
                    )}

                    {activeKey.toUpperCase() == 'NOT-BILLED' && (
                        <NotBilled
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}

                    {activeKey.toUpperCase() == 'BILLED-MANUALLY' && (
                        <BilledManually
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}

                    {activeKey.toUpperCase() == 'PAY-THROUGH-NKR' && (
                        <PayThroughNkrList
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}

                    {(activeKey.toUpperCase() == 'PAYMENT-SUBMITTED-BY' || activeKey.toUpperCase() == 'PAYMENT-SUBMITTED-TO') && (
                        <SubmittedByRecipientCenter
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                            isRecipientCenter={activeKey.toUpperCase() == 'PAYMENT-SUBMITTED-BY'}
                        />
                    )}

                    {activeKey.toUpperCase() == 'AR-SEARCH' && (
                        <Search
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                            isAccountsReceivable={true}
                        />
                    )}

                    {activeKey.toUpperCase() == 'AP-SEARCH' && (
                        <Search
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                            isAccountsReceivable={false}
                        />
                    )}

                    {(activeKey.toUpperCase() == 'VIEW-EDIT') && (
                        <ViewEdit
                            donorId={this.props.id ? this.props.id : 0}
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                            tabText={this.state.tabText}
                            onLoaded={this.handleViewEditLoaded}
                        />
                    )}

                    {activeKey.toUpperCase() == 'VIEW-CHARGES' && (
                        <ViewCharges
                            donorId={this.props.id ? this.props.id : 0}
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                            tabText={this.state.tabText}
                            onLoaded={this.handleViewEditLoaded}
                        />
                    )}

                    {(activeKey.toUpperCase() == 'PAY' || activeKey.toUpperCase() == 'PAYMENT-VIEW-EDIT') && (
                        <PayThroughNkr
                            donorId={this.props.id ? this.props.id : 0}
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                            section={activeKey}
                            tabText={this.state.tabText}
                            onLoaded={this.handleViewEditLoaded}
                        />
                    )} */}

                    {activeKey.toUpperCase() == 'ACCOUNTS-RECEIVABLE' && (<>
                        <AccountsReceivable
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    </>)}

                    {activeKey.toUpperCase() == 'ACCOUNTS-RECEIVABLE-OPO' && (<>
                        <AccountsReceivableOpo
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    </>)}


                    {activeKey.toUpperCase() == 'ACCOUNTS-PAYABLE' && (
                        <AccountsPayable
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}


                    {activeKey.toUpperCase() == 'ACCOUNTS-PAYABLE-TOTAL' && (
                        <AccountsPayableTotal
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}

                    {activeKey.toUpperCase() == 'ACCOUNTS-TOTAL-STATEMENT' && (
                        <AccountsTotalStatement
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />
                    )}
                </ContentWrapper>
            </div>
        );
    }
}

export default Billing;